






















import VueOptions from '@utils/VueOptions'
import SuperContainerView from '@superUI/Containers/SuperContainerView'

settings = 
  name: "CsvExportPage"
  components: { SuperContainerView }
  vue:
    methods:
      exportCsv: (payload) ->
        await @triggerSlug("csv_export", payload)
        @showMessage("Csv sent to email.")


export default VueOptions.vue settings
